export default {
  disclaimerMarginTop: '',
  disclaimerColor: 'var(--digi-blue-700)',
  disclaimerMaxWidth: '60rem',
};
